import {h} from 'preact';

export default function FlexTable (props) {

  const tableData = [];
  props.component.data.groupingsDown.groupings.map( (ele, idx) => {
    const key = `${idx}!T`;
    tableData[idx] = [];
    tableData[idx].push(ele.label);
    tableData[idx].push(props.component.data.factMap[key].aggregates[0].label);
  });

  const groupingNames = props.component.meta.properties.groupings.map((ele) => {
    return props.component.data.reportExtendedMetadata.groupingColumnInfo[ele.name].label;
  });

  const aggregatesNmaes = props.component.meta.properties.aggregates.map((ele) => {
    return props.component.data.reportExtendedMetadata.aggregateColumnInfo[ele.name].label;
  });

  return (
    <div class={"component--type__" + props.type}>
    { props.component.meta.header &&
      <p class="container--header">{props.component.meta.header}</p>
    }
    <table>
      <tr>
        <th>{groupingNames[0]}</th>
        <th>{aggregatesNmaes[0]}</th>
      </tr>
      {tableData.map((row, idx) => {
        return (
          <tr key={idx}>
            {row.map((cell, idx) => {
              return (
                <td key={idx}>{cell}</td>
              );
            })}
          </tr>
        );
      })}
    </table>
    { props.component.meta.footer &&
      <p class="container--footer">{props.component.meta.footer}</p>
    }
    </div>
  )
}
